import React, { useState } from "react";
import "./hero.css";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DmsBookingModal from "./dmsBookingModal.js";

const DmsHero = () => {
  const [showDmsModal, setShowDmsModal] = useState(false);

  return (
    <>
      <section className="dms-hero-section">
        <div
          className="dms-hero-background-shape dms-shape-one"
          aria-hidden="true"
        ></div>
        <div
          className="dms-hero-background-shape dms-shape-two"
          aria-hidden="true"
        ></div>
        <div
          className="dms-hero-background-shape dms-shape-three"
          aria-hidden="true"
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-9 col-lg-10 col-md-11 col-12">
              <div
                className="dms-hero-content"
                data-aos="fade-up"
                data-aos-duration="900"
                data-aos-delay="100"
              >
                <div
                  className="dms-hero-eyebrow"
                  data-aos="fade-up"
                  data-aos-duration="700"
                  data-aos-delay="100"
                >
                  SMARTER DISTRIBUTION. FASTER SALES. COMPLETE VISIBILITY.
                </div>
                <h1>
                  Transform Your Distribution
                  <br />
                  Network into a <span>Profit Engine</span>
                </h1>
                <p
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="200"
                >
                  Techcognics DMS helps manufacturers and FMCG businesses
                  digitize their distribution network, improve distributor
                  visibility, streamline order-to-delivery operations and make
                  faster, data-driven decisions.
                  <br />
                  Manage distributors, dealers, orders, inventory, secondary
                  sales, schemes, claims, payments and distribution operations
                  from one intelligent platform.
                </p>
                <div
                  className="dms-hero-flow"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="300"
                >
                  <span>Manufacturer</span>
                  <i>→</i>
                  <span>Distributor</span>
                  <i>→</i>
                  <span>Sales Team</span>
                  <i>→</i>
                  <span>Retailer</span>
                </div>
                <div
                  className="dms-hero-actions"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="400"
                >
                  <button
                    type="button"
                    className="dms-btn-two dms-btn-primary"
                    onClick={() => setShowDmsModal(true)}
                  >
                    Book a Free Demo
                    <span className="dms-btn-icon">
                      <ArrowForwardIcon fontSize="small" />
                    </span>
                  </button>
                  <button
                    type="button"
                    className="dms-btn-two dms-btn-secondary"
                    onClick={() => setShowDmsModal(true)}
                  >
                    Talk to a DMS Expert
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <DmsBookingModal
        show={showDmsModal}
        onClose={() => setShowDmsModal(false)}
      />
    </>
  );
};

export default DmsHero;
